import Notices from './Notices/Notices'
import { useEffect } from 'react'
import { NoticeStore } from '../state/NoticeStore'
import { ContainerWrapper } from './Container'
import TopBar from './TopBar'
import ShallowHeader from './ShallowHeader'
import { UserStore } from '../state/UserStore'
import { ModalStore } from '../state/ModalStore'
import { useRouter } from 'next/router'
import CoachingCallModal from './Modals/CoachingCallModal'
import { has } from 'lodash'
import HomepageHeader from './HomePageV2/HomepageHeader'

function HeaderTopLevel(props) {
    const resetNotices = NoticeStore((state) => state.reset)
    const user = UserStore((state) => state.user)

    const addModal = ModalStore((state) => state.add)
    const router = useRouter()

    const title = props.title || props.meta?.title
    const phoneNumber = props?.phoneNumber || '978-269-0245'

    useEffect(() => {
        if (has(router.query, 'BookACoachingCall')) {
            addModal(<CoachingCallModal />)
        }
    }, [router.query, addModal])

    useEffect(() => {
        // Remove Notices when changing page
        resetNotices()
    }, [resetNotices, router.asPath])

    return (
        <div>
            <ShallowHeader
                {...props}
                renderMeta={!!props?.meta && !props?.ssrInjected}
                renderScripts={true}
            />
            <div className="pb-0">
                <TopBar user={user} />
                <HomepageHeader
                    hideNavigation={props.hideNavigation}
                    hideCartButton={props.hideCartButton}
                    hideLoginButton={props.hideLoginButton}
                    phoneNumber={phoneNumber}
                    disableLogoLink={props.disableLogoLink}
                    bookCallCtaLabel={props.bookCallCtaLabel}
                    bookCallModalProps={props.bookCallModalProps}
                />
            </div>
            <ContainerWrapper>
                {title && !props.hideTitle && (
                    <div className="px-5 pt-5 md:px-0">
                        <h1 className="text-4xl pt-5 px-5 md:px-0">{title}</h1>
                    </div>
                )}
            </ContainerWrapper>
            <Notices />
        </div>
    )
}

export default HeaderTopLevel
